module.exports = __webpack_public_path__ + "static/media/toro_rosso.7a9903bc.jpg";